export default function nameToInitials(name: string): string {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    ?.toUpperCase()
    .slice(0, 2);
}
